import { format } from 'date-fns';

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
  };



export const formatDateOnly = (date, dateFormat = 'yyyy-MM-dd') => {
  return format(date, dateFormat);
};


  